<template>
  <div class="container">
    <div class="flex border-b">
      <h2 class="size18 bold" :style="{ paddingBottom: showViceTitle ? '30px' : '10px' }">
        联系经纪人
      </h2>
      <span v-show="showViceTitle" style="margin-left: 30px" class="size14 gray">您可以通过电话联系经纪人</span>
    </div>

    <ul>
      <li class="flex pv20 cursor" v-for="(agent, index) in recommendAgent" :key="agent.guid"
        :class="{ 'border-b': index !== recommendAgent.length - 1 }" v-show="index < 3" @click="goAgentShop(agent)">
        <div class="recommenAvatar">
          <img v-if="agent.avatar" class="all fillet" :src="agent.avatar" alt="" />
          <img v-else class="all fillet" :src="agentAvatar" alt="" />
        </div>
        <div class="flex1">
          <div class="flex sb_start">
            <div>
              <div class="flex s_center">
                <h3>{{ agent.trueName || '经纪人' }}</h3>

              </div>
              <div class="departmentName size10 mt5">
                <!-- {{ agent.departmentName || "名盛房产" }} -->
                {{ companyConfig.firstName + companyConfig.lastName }}
              </div>
              <div class="whiteGray size10 pt5">
                {{ agent.manType == 2 ? '楼栋专家' : '好评经纪人' }}
                {{ index == 0 ? '' : '，熟悉本房特色' }}</div>
            </div>
            <div class="flex btnBox">
              <div v-if="agent.fixTel || agent.mobile">
                <el-button @click.stop="" size="small" class="greenBG  tButton phoneButton">
                  <i class="el-icon-phone"></i>
                  {{ agent.fixTel || agent.mobile }}
                </el-button>
              </div>
              <div @click.stop="openChat(agent)" style="margin-left: 10px;">
                <!-- @click.stop="$emit('show-code', agent)" -->
                <el-button size="small" plain class="greenBG  green tButton chatButton">
                  <i class="el-icon-chat-dot-round green"></i>
                  在线问
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div v-show="showRecommend && !isSourceERP" class="mt20 pb40 border-b flex" @click="$emit('change-collection')">
      <el-button class="flex1">{{
        isEstateAttention ? "取消关注" : "关注房源"
      }}</el-button>
    </div>
  </div>
</template>
<script>
import Constant from "../common/Constant.js";
import { mapState } from "vuex";
import { EventBus } from '@/common/EventBus';
import SessionCache from '@/common/Session';
export default {
  name: "",
  props: {
    title: {
      type: String,
      required: true,
    },
    recommendAgent: {
      type: Array,
      required: true,
    },
    showViceTitle: {
      type: Boolean,
      default: false,
      required: false,
    },
    isEstateAttention: {
      default: false,
    },
    showRecommend: {
      type: Boolean,
      required: true,
    },
    // 新增：房源信息属性，用于发送房源卡片
    houseInfo: {
      type: Object,
      default: () => ({})
    },
    tradeType: {
      type: [Number, String],
      default: 2
    },
  },
  data() {
    return {
      agentAvatar: Constant.DEFAULT_AVATAR,
    };
  },
  computed: {
    ...mapState(["isSourceERP", "companyConfig", "user"])
  },
  methods: {
    goAgentShop(agent) {
      this.$router.push({
        path: "/agentShop",
        query: {
          guid: agent.guid,
        },
      });
    },
    // 打开聊天窗口
    async openChat(agent) {
      if (this.user && this.user.account && this.user.account.guid) {
        const agentInfo = {
          agentAccountGuid: agent.accountGuid || agent.guid,
          agentName: agent.trueName || '经纪人',
          agentAvatar: agent.avatar || Constant.DEFAULT_AVATAR,
          agentGuid: agent.guid,
          agentMobile: agent.mobile || agent.fixTel,
          roles: 'agent',
          houseInfo: this.houseInfo,
          tradeType: this.tradeType,
          autoSendHouseCard: true
        };

        // 先检查IM是否已登录
        const imState = this.$store.state.im || {};

        if (!imState.isLogin || !imState.imInstans) {
          // 显示加载
          const loading = this.$loading({
            lock: true,
            text: '正在连接IM...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          try {
            const token = SessionCache.getAccessToken();
            const customerInfo = SessionCache.getCustomerInfo();

            if (!token || !customerInfo?.account?.guid) {
              loading.close();
              this.$store.commit("updateState", {
                data: true,
                key: "showLogin"
              });
              return;
            }

            // 初始化IM
            await this.$store.dispatch('im/initIM', {
              account: customerInfo.account.guid,
              token: token,
              callbackv2: () => {
                console.log('[IM] 初始化成功');
              }
            });

            // 等待连接稳定
            await new Promise(resolve => setTimeout(resolve, 1500));
            loading.close();

            // 继续执行聊天开启
            await this.startChatProcess(agentInfo);

          } catch (error) {
            loading.close();
            console.error('IM连接失败:', error);
            this.$message.error('连接IM失败，请刷新页面重试');
          }
        } else {
          // 已登录，直接开启聊天
          await this.startChatProcess(agentInfo);
        }
      } else {
        this.$store.commit("updateState", {
          data: true,
          key: "showLogin"
        });
      }
    },
    // 在 openChat 方法中，修改调用方式
    async startChatProcess(agentInfo) {
      const loading = this.$loading({
        lock: true,
        text: '正在开启聊天...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {

        // 关键：先尝试获取完整的好友列表
        const imState = this.$store.state.im || {};

        // 如果好友列表为空，先加载已有的好友
        if (!imState.friendslist || imState.friendslist.length === 0) {
          // 先重置并加载好友列表
          await this.$store.dispatch('im/resetAndLoadFriends');

          // 等待好友列表加载完成
          await new Promise(resolve => setTimeout(resolve, 500));
        }

        const success = await this.$store.dispatch('im/ensureFriendAndChat', agentInfo);

        if (success) {
          // 先打开聊天窗口
          EventBus.$emit('open-im-dialog', agentInfo);

          // 等待一下确保会话已创建
          await new Promise(resolve => setTimeout(resolve, 800));

          // 发送房源卡片
          if (this.houseInfo && Object.keys(this.houseInfo).length > 0) {

            const sent = await this.$store.dispatch('im/sendHouseCardAfterChat', {
              agentGuid: agentInfo.agentAccountGuid,
              houseInfo: this.houseInfo,
              tradeType: this.tradeType
            });

            if (sent) {
              // 发送成功后，主动切换当前会话，确保会话列表高亮
              await this.$store.dispatch('im/setCurrentSession', agentInfo.agentAccountGuid);
            } else {
              // 如果 sendHouseCardAfterChat 失败，尝试直接发送
              setTimeout(async () => {
                await this.$store.dispatch('im/sendHouseCardDirectly', {
                  fromGuid: this.$store.state.im.userGuid,
                  targetGuid: agentInfo.agentAccountGuid,
                  houseInfo: this.houseInfo,
                  tradeType: this.tradeType
                });
              }, 500);
            }
          }

          loading.close();
        } else {
          loading.close();
          this.$message.error('开启聊天失败，请重试');
        }
      } catch (error) {
        loading.close();
        console.error('开启聊天失败:', error);
        this.$message.error('开启聊天失败：' + (error.message || '未知错误'));
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pb40 {
  padding-bottom: 40px;
}

.flex1 {
  position: relative;
}

.btnBox {
  position: absolute;
  right: 0;
  top: 0;

}

.recommenAvatar {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-right: 22px;
}

.departmentName {
  width: 42px;
  padding: 0 3px;
  height: 24px;
  line-height: 24px;
  color: #889ebc;
  background-color: #f2f5f7;
  border-radius: 2px;
}

.tButton {
  color: #fff;
  border-radius: 1px;

  .i {
    color: #fff;
  }
}

.phoneButton:hover {
  background: #f0fef8;
  box-sizing: border-box;
  border: #00ae66 1px solid;
  color: #00ae66;

  .i {
    color: #00ae66;
  }
}

.chatButton {
  background: #f0fef8;
  border: #00ae66 1px solid;
  color: #00ae66;

  .i {
    color: #00ae66;
  }
}

.chatButton:hover {
  box-sizing: border-box;
  background: #fff;
  color: #00ae66;
  border: #00ae66 1px solid;

  .i {
    color: #00ae66;
  }
}
</style>